import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gc_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const LOGOUT_REASON_KEY = "gc_logout_reason";

export function forceLogout(reason) {
  if (!localStorage.getItem("gc_token")) return;
  localStorage.removeItem("gc_token");
  sessionStorage.setItem(LOGOUT_REASON_KEY, reason || "Session khatam ho gaya, dobara login karo");
  window.location.replace("/login");
}

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !(err.config?.url || "").includes("/auth/login")) {
      const d = err.response.data?.detail;
      forceLogout(typeof d === "string" && /password|Security/i.test(d) ? d : "");
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}

/**
 * Build an auth-friendly download URL for a GridFS file. Attaches the
 * current token as a query param so <img src> / <a href> can hit
 * /api/files/{id} without an interceptor.
 */
export function getFileUrl(fileId) {
  if (!fileId) return "";
  const token = localStorage.getItem("gc_token") || "";
  return `${API_BASE}/files/${fileId}?token=${encodeURIComponent(token)}`;
}
